import { Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@node_modules/@angular/common';
import { NgbActiveModal } from '@node_modules/@ng-bootstrap/ng-bootstrap';

/**
 * CPW-5547: offers a visitor the cable sizing calculator matching their detected region.
 *
 * Purely presentational - it knows nothing about detection or navigation. The caller
 * (WebfacingHeaderV2Component) decides whether to open it and handles the result, so that
 * switching reuses the existing onStandardChange() navigation path.
 *
 * Result contract:
 *   close('switch')     - the visitor accepted the suggested standard
 *   dismiss('dismiss')  - the visitor declined, via the secondary button or the close icon
 */
@Component({
  selector: 'app-regional-standard-modal',
  templateUrl: './regional-standard-modal.component.html',
  styleUrls: ['./regional-standard-modal.component.scss'],
  standalone: true,
  imports: [CommonModule],
  // The card's rounded corners and padding replace Bootstrap's .modal-content chrome, which lives
  // outside this component's view and so is unreachable from an encapsulated stylesheet. Every
  // selector is scoped under .regional-standard-modal-window (passed as NgbModal's windowClass)
  // and prefixed rs-, so nothing leaks into the rest of the app.
  encapsulation: ViewEncapsulation.None
})
export class RegionalStandardModalComponent {

  /** Full country name, e.g. 'United States'. */
  detectedCountryName: string = '';

  /** ISO 3166-1 alpha-2, e.g. 'US'. Selects the flag asset. */
  detectedCountryCode: string = '';

  /** Name of the suggested standard, e.g. 'NEC NFPA 70'. */
  detectedShortName: string = '';

  /** Name of the standard currently being viewed, e.g. 'AS/NZS 3008.1.1'. */
  currentShortName: string = '';

  /** Set when the flag asset fails to load, so the badge falls back to the bare pin. */
  flagFailed: boolean = false;

  constructor(public activeModal: NgbActiveModal) { }

  get flagSrc(): string {
    return `assets/custom/img/flags/${this.detectedCountryCode.toLowerCase()}.svg`;
  }
}
